import {Navigate, Route, Routes} from "react-router-dom"
import {Home} from "../sections/home"
import {BaseLayout} from "../reusable_components/base_layout/baseLayout";
import {Canvas} from "../sections/canvas";
import {NewArchitecture} from "../sections/new_architecture";

export const PageRouter = () => {
    return (
        <Routes>
            <Route element={<BaseLayout disableContentPaddings={true} />}>
                <Route path='/' element={<Home/>} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Route>

            <Route element={<BaseLayout />}>
                <Route path='/new-architecture' element={<NewArchitecture/>} />
                <Route path='/architectures/:id' element={<Canvas/>} />
            </Route>
        </Routes>
    )
}
